<template>
    <v-card>
        <v-card-title>
            <v-spacer />
            <v-btn small icon class="mr-2" @click="$emit('close')">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-card-title>

        <v-card-text class="px-5 pb-5">
            <div align="center" class="mb-4">
                <v-img
                    :src="require('@/assets/img/search.svg')"
                    height="100"
                    width="100"
                />
            </div>

            <div class="text-center">
                Anda masih memiliki proses yang belum diselesaikan, ingin
                melanjutkan?
            </div>

            <div class="mt-7">
                <v-row class="d-flex align-center d-flex">
                    <v-col>
                        <v-btn
                            color="blew"
                            dark
                            depressed
                            block
                            height="40px"
                            @click="$emit('confirm')"
                        >
                            Ya
                        </v-btn>
                    </v-col>

                    <v-col>
                        <v-btn
                            color="blew"
                            outlined
                            depressed
                            block
                            height="40px"
                            style="border: 1.6px solid"
                            @click="$emit('close')"
                        >
                            Tidak
                        </v-btn>
                    </v-col>
                </v-row>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    props: {
        liveClassTotal: { type: Number, default: 0 },
        liveClassTotalErrorExcel: { type: Number, default: [] },
    },
    name: "DialogConfirmSessionUpload",
};
</script>



// WEBPACK FOOTER //
// DialogConfirmSessionUpload.vue?e2a2a2fc